import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import toast from 'react-hot-toast';
import { FacebookConnect } from './FacebookConnect';
import { InstagramConnect } from './InstagramConnect';
import { LinkedInConnect } from './LinkedInConnect';
import { GoogleBusinessConnect } from './GoogleBusinessConnect';
import { XConnect } from './XConnect';

export function ConnectButtons() {
  const [accounts, setAccounts] = useState<any[]>([]);

  useEffect(() => {
    loadAccounts();
  }, []);

  const loadAccounts = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();

      if (!user) {
        return;
      }

      const { data, error } = await supabase
        .from('connected_accounts')
        .select('*')
        .eq('user_id', user.id);

      if (error) throw error;
      setAccounts(data || []);
    } catch (error) {
      console.error('Error loading accounts:', error);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow p-4 mb-6">
      <h3 className="text-lg font-semibold mb-4">Podłącz konta społecznościowe</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        <FacebookConnect
          onSuccess={loadAccounts}
          onError={(error) => toast.error(error)}
          hasConnectedAccounts={accounts.some(a => a.platform === 'facebook')}
        />
        <InstagramConnect
          onSuccess={loadAccounts}
          onError={(error) => toast.error(error)}
          hasConnectedAccounts={accounts.some(a => a.platform === 'instagram')}
        />
        <LinkedInConnect
          onSuccess={loadAccounts}
          onError={(error) => toast.error(error)}
          hasConnectedAccounts={accounts.some(a => a.platform === 'linkedin')}
        />
        <GoogleBusinessConnect
          onSuccess={loadAccounts}
          onError={(error) => toast.error(error)}
          hasConnectedAccounts={accounts.some(a => a.platform === 'google_business')}
        />
        <XConnect
          onSuccess={loadAccounts}
          onError={(error) => toast.error(error)}
          hasConnectedAccounts={accounts.some(a => a.platform === 'x')}
        />
      </div>
    </div>
  );
}
